export default __webpack_public_path__ + "static/media/news_radio.09d51bdb.png";